/* eslint-disable no-unused-vars */
/* eslint-disable */
import React, { useState, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import SelectDateFilter from 'modules/common/components/SelectDateFilter';
import moment from 'moment';
import PropTypes from 'prop-types';
import withDashboard from '../../../common/hoc/withDashboard';

import * as actions from '../action';
import * as c from '../constant';
import EwalletChartComponent from '../components/EwalletChartComponent';

const colors = ['#A3B3F9',
    '#B1CDF8',
    '#BBE9FE',
    '#5272AA',
    '#84DAFF',];

const payload = {
    period: 'MONTHLY',
    date_from: moment().startOf('year').format('YYYY-MM-DD'),
    date_to: moment().endOf('year').format('YYYY-MM-DD'),
};

const filter = {
    transaction_type: 'ALL',
};

function EwalletDashboardContainer({
    graphStats,
    getGraphStats,
    // createDynamicAreaChart,
}) {
    const [filterData, setFilterData] = useState(filter);
    const [isLoading, setIsLoading] = useState(true);

    const renderLegends = (dt) =>
        dt.map((x) => {
            return (
                <div key={x.name} className="legend-item">
                    <div
                        style={{
                            background: `${x.color}`,
                            width: 20,
                            height: 20,
                            marginRight: 20,
                        }}
                    />
                    <div className="legend-text">{x.name}</div>
                </div>
            );
        });

    const handleOnSubmit = (data) => {
        getGraphStats(data);
    };

    // const handleOnSubmit = ({ type, from, to }) => {
    //     getGraphStats({
    //         period: type,
    //         date_from: from,
    //         date_to: to
    //     });
    // };

    useEffect(() => {
        getGraphStats(payload);
        setIsLoading(false);
        return () => {
            setIsLoading(false);
        };
    }, []);


    return (
        <div className="dashboard-card">
            <div className="row mb-3">
                <div className="col-12">
                    <div className="text-bold">Sales and Transactions</div>
                </div>
                <div className="col-12">
                    <SelectDateFilter onSubmit={handleOnSubmit} />
                </div>
                <div className="col-12">
                    {/* {createDynamicAreaChart(
                        graphStats.values,
                        graphStats.labels,
                        {
                            xAxisProps: {
                                fontSize: '10px',
                                angle: -35,
                                scale: 'point',
                            },
                            yAxisProps: {
                                angle: -55,
                            },
                            composeOption: {
                                bottom: 20,
                            },
                        },
                        isLoading
                    )}
                     */}
                    <EwalletChartComponent
                        chartData={graphStats}
                    />
                </div>
                <div className="legends-wrapper area px-3 w-100">
                    <div
                        className="render-chart-legends"
                        style={{
                            display: 'flex',
                            alignItems: 'center',
                            flexDirection: 'row',
                            flexWrap: 'wrap',
                        }}
                    >
                        {renderLegends(c.E_WALLET)}
                    </div>
                </div>
            </div>
        </div>
    );
}

EwalletDashboardContainer.propTypes = {
    createDynamicAreaChart: PropTypes.instanceOf(Function).isRequired,
    graphStats: PropTypes.instanceOf(Array).isRequired,
    getGraphStats: PropTypes.instanceOf(Function).isRequired,
};

// const formatGraphData = (data) => {
//     const labels = [];
//     const values = [];

//     data.forEach((item, i) => {
//         const entries = Object.entries(item).filter(
//             (a) => ['name', 'included', 'RPT', 'BPLS'].indexOf(a[0]) < 0
//         );

//         if (i === 0) {
//             entries.forEach((entry, x) => {
//                 labels[x] = {
//                     key: entry[0],
//                     color: colors[x],
//                 };
//             });
//         }

//         values[i] = rename(
//             rename(
//                 rename(item, 'OHP', 'Occupational / Health Permits'),
//                 'CDL',
//                 'Community Tax CertificateCTC / CEDULA'
//             ),
//             'PSA',
//             'Civil Registry Office'
//         );
//     });

//     return {
//         labels,
//         values,
//     };
// };

const mapStateToProps = ({ api }) => ({
    graphStats: _.get(api, `${c.GET_GRAPH_STATS}.list`) || [],
});

const enhance = _.flowRight([
    withDashboard,
    withRouter,
    connect(mapStateToProps, actions),
]);

export default enhance(EwalletDashboardContainer);
